module.exports = __webpack_public_path__ + "static/media/Muli-Regular.0c521373.woff2";